import { useEffect, useState } from "react";

/**
 * A value once it has stopped changing, so a typed word is one request and not
 * five. Shared by every box that searches as you type — `CompanyPicker` and the
 * composer's `RecipientField`.
 */
export function useSettled<T>(value: T, delay = 250): T {
  const [settled, setSettled] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);
  return settled;
}
